<template>
    <div>
        <!-- 操作证书到期换证审核（小程序） -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link :to="`/certificatecheckzbperson/${checkactiveorgan}/${pageIndex}`">
                        <i class="el-icon-arrow-left"></i>
                        操作证审核 / 总部业务员操作证书到期换证审核
                    </router-link>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
            <p class="purchasesee-title">基本信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item3">
                    <li>证书编码：{{seecerApplylist.operationCertificateNumber}}</li>
                    <li>申请时间: {{seecerApplylist.createTimeStr}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>操作项目：{{seecerApplylist.operationItems}}</li>
                    <li>有效起止日期: {{seecerApplylist.validDate}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>培训起止日期：{{seecerApplylist.studyDate}}</li>
                    <li
                        v-if="seecerApplylist.isFirst != undefined &&seecerApplylist.isFirst == 2"
                    >本证属：换发 岗龄{{seecerApplylist.workAge}}年</li>
                    <li v-else>本证属：初次颁发 岗龄{{seecerApplylist.workAge}}年</li>
                </ul>
            </div>
        </div>

        <p v-if="seecerApplylist.status == 5" style="margin-top: 20px;">
            <el-button type="primary" @click="passcerfirst()">通过</el-button>
            <el-button type="primary" @click="fallbackcerfirst('fallbackform')">退回</el-button>
        </p>

        <el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
            <el-form ref="fallbackform" :model="fallbackform">
                <el-form-item label prop="auditReason">
                    <el-input
                        type="textarea"
                        v-model="fallbackform.auditReason"
                        placeholder="请输入回退原因"
                        class="resizeNone"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savefallbackfirst()">确 定</el-button>
                <el-button @click="fallbackVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getCertificateApply,examineCertificateTimeexpandApply} from '@/api/index';
export default {
    name: 'cercheckseefzbsec',
    data() {
        return {
			certificateApplyId:'',
			activeName:'',
			pageIndex:'',
			certificateTimeexpandApplyId:'',
			seecerApplylist:{},//查看
			fallbackVisible:false,
			fallbackform:{
				auditReason:''
			},
			cerArrId:[]
        };
    },
    created() {
		this.certificateApplyId = this.$route.params.certificateTimeexpandApplyId;
		this.activeName = this.$route.params.checkactiveorgan
		this.pageIndex = this.$route.params.pageIndex
		
		this.cerArrId.push(this.$route.params.certificateTimeexpandApplyId);
		// 查看
		getCertificateApply({},{
			"certificateApplyId": this.certificateApplyId         
		}).then(res => {
					  // 获取数据成功后的其他操作
			this.seecerApplylist = res.data;        
		});
		
    },
    methods: {
    	//审核通过
    	passcerfirst(){
    		var that = this;
    		this.$confirm('确定要通过吗？', '提示', {
    		    type: 'warning'
    		}).then(() => {
    		        examineCertificateTimeexpandApply({
    		        	isPass:1,                    
    		        	certificateTimeexpandApplyIds: this.cerArrId
    		        }).then(res => {
    					if(res.code == 0){
    						// 获取数据成功后的其他操作
    						this.$message({
    						  message: res.message,
    						  type: 'success'
    						});
    						this.$router.push('/certificatecheckzbperson');
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
    					}else {
    						this.$message({
    						  message: res.message,
    						  type: 'error'
    						});
    					}
    		        	
    		        });
    		}).catch(() => {});
    		
    	  },
    	  // 回退弹框
    	  fallbackcerfirst(formName){
    	  	
    	  	this.fallbackVisible = true;
    	  	//重置表单数据
    	  	this.$nextTick(()=>{
    	  	  this.$refs.[formName].resetFields();
    	  	})
    	  	
    	  	
    	  },
    	  
    	  //审核退回
    	  savefallbackfirst(){
    	  	this.$confirm('确定要退回吗？', '提示', {
    	  	    type: 'warning'
    	  	}).then(() => {
    	  	        examineCertificateTimeexpandApply({
    	  				auditReason:this.fallbackform.auditReason,
    	  	        	isPass:2,                    
    	  	        	certificateTimeexpandApplyIds: this.cerArrId            
    	  	        }).then(res => {
    					if(res.code == 0){
    						// 获取数据成功后的其他操作
    						this.$message({
    						  message: res.message,
    						  type: 'success'
    						});
    						this.fallbackVisible = false;
    						this.$router.push('/certificatecheckzbperson');
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
    					}else {
    						this.$message({
    						  message: res.message,
    						  type: 'error'
    						});
    					}
    					
    					
    	  	        });
    	  	}).catch(() => {});
    	  },
    	  
    
    }
};
</script>

<style scoped>
.purchasesee-box {
    background: #fff;
    padding: 20px 0;
}
.purchasesee-title {
    height: 30px;
    line-height: 30px;
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    border-left: 5px solid #437af4;
    text-indent: 30px;
}
.purchasesee-padding {
    padding: 20px 0;
}
.seelicense-item1 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item1 li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-item1 li:last-child {
    flex: 1;
}
.seelicense-item2 {
    padding: 0 35px;
    margin-top: 15px;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item3 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.seelicense-item3 li {
    width: 350px;
}
.seelicense-item4 {
    margin: 0 35px;
    background: #f8f8fb;
    padding: 20px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item4 li {
    margin-bottom: 10px;
}

.purchasesee-text1,
.purchasesee-text2 {
    height: 32px;
    line-height: 32px;
    text-indent: 15px;
}

.purchasesee-text2 {
    text-indent: 50px;
}
.purchasesee-table {
    width: 50%;
    margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo {
    margin: 10px 50px;
    display: flex;
    display: -webkit-flex;
}
.purchasesee-linceitem {
    width: 30%;
}
.purchasesee-linceitem:nth-child(2) {
    margin: 0 3%;
}

.organ-box {
    margin-bottom: 20px;
    text-align: right;
}
.apply-box {
    display: flex;
    display: -webkit-flex;
}
.apply-box p {
    flex: 1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
